import cn from 'classnames';
import { ReactNode, useContext } from 'react';
import { BlockedFeatureContext } from '../access/BlockedFeatureContext';
import { useAppDispatch } from '../../effects/useAppDispatch';
import { errorActions } from '../../actions';
import { ResetErrorLink } from './ResetErrorLink';

interface Props {
    title: string;
    className?: string;
    active: boolean;
    path: string;
    children?: React.ReactNode;
    disabled?: boolean;
    activeClickable?: boolean;
    disabledTooltip?: boolean;
    disabledTooltipText?: ReactNode;
    isNewLabelVisible?: boolean;
    isTrialLabelVisible?: boolean;
}

export function NavBarItem({
    title,
    className,
    active, path,
    children,
    disabled = false,
    activeClickable = false,
    isNewLabelVisible = false,
    isTrialLabelVisible = false
}: Props) {
    const dispatch = useAppDispatch();

    const isBlocked = useContext(BlockedFeatureContext);
    const isDisabled = disabled || (active && !activeClickable) || isBlocked;

    const renderNew = () => isNewLabelVisible && <span className="new-label">new</span>
    const renderTrial = () => isTrialLabelVisible && <span className="new-label">trial</span>

    const renderContent = () => <>{renderNew()}{renderTrial()}{title}{children}</>

    return (
        <li className="navbar-item">
            {isDisabled ? (
                <span className={cn("navbar-link", className, { active, disabled })}>
                    {renderContent()}
                </span>
            ) : (
                <ResetErrorLink
                    className={cn("navbar-link", { active: active && activeClickable })}
                    to={path}
                    onClick={() => dispatch(errorActions.resetError())}
                >
                    {renderContent()}
                </ResetErrorLink>
            )
            }
        </li>
    );
}
